// extracted by mini-css-extract-plugin
export default {"iconSelect":"TeamGalleryContent_iconSelect__H7NWj","containerFlex":"TeamGalleryContent_containerFlex__NazKv","containerFlexMobile":"TeamGalleryContent_containerFlexMobile__QqmGN"};